import {Basic} from "./Basic";

// noinspection ExceptionCaughtLocallyJS
export class Load
{
    static TIMEOUT = 10000;

    static async fetch(myData)
    {
        document.documentElement.classList.add('w__waiting');

        if(!myData.url)
        {
            myData.url = document.location.pathname;
        }

        myData.time = new Date().getTime();

        const controller = new AbortController(),
              timeoutId = setTimeout(() => controller.abort(), Load.TIMEOUT);

        try
        {
            const response = await fetch(Basic.base + 'index.php',{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'Accept': 'application/json'
                },
                body: 'json=' + encodeURIComponent(JSON.stringify(myData)),
                signal: controller.signal
            });

            if(!response.ok)
            {
                throw new Error(`HTTP error: ${response.status} - ${response.statusText}`);
            }

            const data = await response.json();

            if(data.status === true)
            {
                return data;
            }
            else
            {
                throw data;
            }
        }
        catch(error)
        {
            console.error('Load.fetch()', error);

            if(error.name === 'AbortError')
            {
                throw 'Request timed out. Network problems?';
            }
            else
            {
                throw error;
            }
        }
        finally
        {
            clearTimeout(timeoutId);
            document.documentElement.classList.remove('w__waiting');
        }
    }
}

